module.exports = __webpack_public_path__ + "static/PitPayPitPassApp-be3b8fa703f09b788c2f96910290bb77.svg";